const lazyVideoInit = () => {
  document.addEventListener('DOMContentLoaded', () => {
    const lazyVideos = [...document.querySelectorAll('video.video-embed-item')];
    const $videos = document.querySelectorAll('.video .embed');
    lazyVideos.forEach(video => {
      [...video.children].forEach($el => {
        if ($el.tagName === 'SOURCE') {
          const videoSrc = $el.dataset.src;
          if (videoSrc) $el.src = videoSrc;
        }
      });
      video.load();
      video.classList.remove('lazy');
    });
    $videos.forEach($videoWrapper => {
      const $playBtn = $videoWrapper.querySelector('.js-play');
      const $pauseBtn = $videoWrapper.querySelector('.js-pause');
      const $video = $videoWrapper.querySelector('video');
      let pause = true;
      if (!$video) return;
      const toggleBtn = e => {
        pause = e.type === 'pause';
        $playBtn.classList.toggle('d-none', !pause);
        $pauseBtn.classList.toggle('d-none', pause);
        $videoWrapper.classList.toggle('_playing', !pause);
        $videoWrapper.classList.toggle('_pause', pause);
      };
      const toggleVideo = () => {
        if (pause) {
          $video.play();
          return;
        }
        $video.pause();
      };
      $video.controls = false;
      if (!$playBtn && !$pauseBtn) return;
      $playBtn.addEventListener('click', toggleVideo);
      $pauseBtn.addEventListener('click', toggleVideo);
      $video.addEventListener('playing', toggleBtn);
      $video.addEventListener('pause', toggleBtn);
      if ($video.autoplay) {
        $playBtn.classList.add('d-none');
        $pauseBtn.classList.add('d-none');
      }
    });
  });
};
export default lazyVideoInit;